document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.section-shop-by-collection_wrap').forEach(function(colltabsider) {
    const tabButtons = colltabsider.querySelectorAll('.featured_collection_tab_button');
    const tabPanels = colltabsider.querySelectorAll('.featured_collection_tab_panel');
    let currentIndex = Array.from(tabPanels).findIndex(el => el.classList.contains('active'));
    let isAnimating = false;
    let swipers = []; // keep your swiper setup here if needed

    tabButtons.forEach((btn, index) => {
      btn.addEventListener('click', () => {
        if (isAnimating || index === currentIndex) return;
        isAnimating = true;
        tabButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        const current = tabPanels[currentIndex];
        current.classList.remove('active');
        current.classList.add('hidden');

        const next = tabPanels[index];
        next.classList.remove('hidden');

        setTimeout(() => {
          next.classList.add('active');
          if (swipers[index]) {
            swipers[index].slideTo(0, 0);
          }
          currentIndex = index;
          isAnimating = false;
        }, 10);
      });
    });
  });
});
